<div class="version-widget">
    <button (click)="setCurrentVersion()">{{ 'SHARED.SET_AS_CURRENT' | translate }}</button>
    <button (click)="exitVersionPreview()">{{ 'SHARED.EXIT_PREVIEW' | translate }}</button>
  </div>
  